package com.neurobs.ccabserver.transcriptreview.components.transcriptreview

import com.neurobs.ccabserver.transcriptreview.states.UserState
import com.neurobs.ccabserver.transcriptreview.components.transcriptreview.components.{TestTranscriptReviewInfoBar, TranscriptLabelColumn, TranscriptText}
import com.neurobs.react.StyleUtil
import com.neurobs.ccabserver.transcriptreview.states.{RecordingTranscriptReviewStateProvider, TestTranscriptReviewStateGenerator, TranscriptTableStateProvider}
import com.neurobs.ccabserver.transcriptreview.util.RecordingTranscriptReviewHandler
import com.neurobs.js.view.AudioViewer
import org.scalajs.dom
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.{useEffect, useState}
import slinky.web.html._
import slinky.core.facade.{React, ReactElement}

@react
object TestTranscriptReview {
	case class Props()

	val component = FunctionalComponent[Props] { props =>
		val testState = TestTranscriptReviewStateGenerator.accessState
		val userState = UserState.accessState


		val transcriptRowDiv = React.createRef[dom.html.Div]
		val (transcriptRowHeight, updateTranscriptRowHeight) = useState(default = 200)

		useEffect(() => {
			if (transcriptRowDiv.current != null) {
				updateTranscriptRowHeight(transcriptRowDiv.current.clientHeight)
				//println(s"client height ${transcriptRowDiv.current.clientHeight}")
			}
		})

		def recordingReviewComponent(handler: RecordingTranscriptReviewHandler, viewer: AudioViewer, recordingIndex: Int): ReactElement = {
			RecordingTranscriptReviewStateProvider(
				handler = handler,
				viewer = viewer,
				recordingIndex = recordingIndex
			)(
				TranscriptTableStateProvider(
					RecordingTranscriptView(viewer)
				)
			)
		}

		val testHandler = testState.handler.value
		val serverData = testHandler.sourceData.serverData

		div(className := "ui grid", style := StyleUtil.makeStyle(("width", "100%"), ("marginLeft", "0"), ("marginTop", "0px")))(
			TestTranscriptReviewInfoBar(serverData.selection, serverData.logfileName, userState.userId),
			div(className := "sixteen wide column")(
				TestTranscriptReviewOptions()
			),
			TranscriptText(),
			div(style := StyleUtil.makeStyle(("width", "93vw"), ("overflowX", "auto")), ref := testState.containerRef)(
				div(className := "row-container", ref := transcriptRowDiv)(
					div(className := "row-container-element")(
						TranscriptLabelColumn(testState.handler.value.labelList.labels(), transcriptRowHeight)
					),
					testHandler.recordings.zipWithIndex.map(zipped => {
						val (recordingHandler, index) = zipped
						div(className := "row-container-element", key := recordingHandler.code)(
							recordingReviewComponent(recordingHandler, testState.audioViewers.value.viewers(index).viewer, index)
						)
					})
				)
			)
		)
	}
}
